<template>
  <div class="col-12">
    <ValidationObserver ref="form" v-slot="{ handleSubmit }">
      <div
        class="row bg-light-gray border-radius--light pb-3 pt-1"
        style="border-radius: 5px 5px 0px 0px"
      >
        <div class="col-12 col-sm-6 col-md-4 pt-2">
          <ValidationProvider v-slot="{ errors }" rules="required">
            <label class="input-label">Nombre:</label>
            <input
              v-model="model.name"
              :class="{ 'was-Invalidated': errors[0] }"
              type="text"
              class="form-control"
              :disabled="useRole && cannotEditName"
            />
            <small v-if="errors[0]" class="text-danger">
              <i class="fa fa-times-circle mr-2" />
              Favor escriba nombre.
            </small>
          </ValidationProvider>
        </div>
        <div
          v-if="useRole && item.role.name"
          class="col-12 col-sm-6 col-md-4 pt-2"
        >
          <label class="input-label">{{ roleLabel }}:</label>
          <input
            v-model="userProfile.role"
            type="text"
            class="form-control"
            :disabled="useRole"
          />
        </div>
        <div v-else class="col-12 col-sm-6 col-md-4 pt-2">
          <ValidationProvider v-slot="{ errors }" rules="required">
            <label class="input-label">Puesto:</label>
            <CustomDropDown
              v-model="model.position"
              placeholder="Seleccione"
              fieldkey="id"
              fieldname="name"
              :options="catalog.positions"
              :error="errors[0]"
              :disabled="useRole"
            />
            <small v-if="errors[0]" class="text-danger">
              <i class="fa fa-times-circle mr-2" />
              Favor seleccione puesto.
            </small>
          </ValidationProvider>
        </div>
        <div class="col-12 col-sm-6 col-md-4 pt-2">
          <label class="input-label">Teléfono:</label>
          <CustomInput
            v-model="model.phone"
            mask-type="Phone"
            :masked="false"
            placeholder="(__) __-____"
          />
        </div>
        <div class="col-12 col-sm-6 col-md-4 pt-2">
          <ValidationProvider
            v-slot="{ errors }"
            :custom-messages="{
              email: 'El campo debe ser un correo electrónico válido.',
              required: 'Favor escriba correo electrónico.',
              regex:
                'El correo electrónico debe ser de la agencia de.pr.gov o miescuela.pr',
            }"
            :rules="{
              required: true,
              email: true,
              regex: isDirectorPrivadoOrMaestroPrivado
                ? ''
                : /@(de.pr.gov|miescuela.pr)$/gim,
            }"
          >
            <label class="input-label">Correo Electrónico:</label>
            <input
              v-model="model.email"
              :class="{ 'was-Invalidated': errors[0] }"
              type="text"
              name=""
              class="form-control"
            />
            <small v-if="errors[0]" class="text-danger">
              <i class="fa fa-times-circle mr-2" />
              <span v-text="errors[0]" />
            </small>
          </ValidationProvider>
        </div>
      </div>
      <div
        class="row bg-light-gray border-radius--light pb-3  pt-1"
        style="border-radius: 0px 0px 5px 5px"
      >
        <div
          class="col-12 col-md-2 offset-md-10 pl-3 pr-2 d-flex align-items-end justify-content-end"
        >
          <action-button
            variant="outline-danger m-1"
            :i="`fas fa-times-circle`"
            :responsive="true"
            @click="cancel"
          >
            Cancelar
          </action-button>
          <action-button
            variant="success m-1"
            :i="`fas fa-${editting ? 'save' : 'file-plus'}`"
            :responsive="true"
            @click="handleSubmit(submit)"
          >
            {{ editting ? 'Guardar' : 'Añadir' }}
          </action-button>
        </div>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import { CustomInput, CustomDropDown } from '@/components/common';
import ActionButton from 'ActionButton';
import CheckBox from 'CheckBox';
import Error from 'custom-error';
import userRole from '@/utils/constants/userRoles';

const modelInitialState = () => ({
  name: null,
  email: null,
  phone: null,
  position: null,
  role: null,
});

export default {
  name: 'RequesterForm',
  components: {
    CustomInput,
    ActionButton,
    CustomDropDown,
    CheckBox,
    Error,
  },
  props: {
    item: { type: Object, default: null },
    editting: { type: Boolean, default: false },
    cannotEditName: { type: Boolean, default: false },
    useRole: { type: Boolean, default: false },
    catalog: {
      type: Object,
      required: true,
      default: () => ({ positions: [] }),
    },
    roleLabel: {
      type: String,
      default: 'Rol',
    },
  },
  data: () => ({ model: modelInitialState() }),
  methods: {
    submit() {
      if (this.useRole) {
        this.model.role = this.item.role;
      }
      this.$emit('submit', this.model, this.cancel);
    },
    cancel() {
      this.model = modelInitialState();
      this.$refs['form'].reset();
      this.$emit('cancel');
    },
  },
  computed: {
    isDirectorPrivadoOrMaestroPrivado() {
      const roles = [userRole.directorPrivado, userRole.maestroPrivado];
      return roles.some((role) => role === this.userProfile.role);
    },
  },
  created() {
    this.model.email = this.userProfile.email;
    if (this.item) {
      this.model = { ...this.model, ...this.item };
    }
  },
};
</script>

<style lang="scss" scoped>
.input-label {
  color: #727272;
  font-size: 15px;
  font-weight: lighter;
}

.was-Invalidated {
  border: 1px solid red;
}
</style>
